define('views/modules/template/assignment/list/per-user/per-user-assignment-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'bootbox', 'utils',
    // services
    'services/i18n',
    // views
    'views/parts/media-info-box',
    // templates
    'text!templates/modules/template/assignment/list/assignment-list-item-content.html'
], function(
    // Libs
    _, Backbone, Mustache, Bootbox, U,
    // services
    i18n,
    // views
    VMediaInfoBox,
    // templates
    TAssignmentListItemContent
) {

    var VPerUserAssignmentListItem = Backbone.View.extend({
        className: 'assignment-list-item',

        initialize: function(opt) {
            this.options = opt || {};

            var model = this.model,
                view = this.view = {
                    infobox: new VMediaInfoBox({
                        title: 'name',
                        model: model,
                        context: this,
                        extraContent: TAssignmentListItemContent,
                        onClick: this.onClick,
                        menu: {
                            init: this.onMenuInit,
                            onClick: this.onActionClick,
                        }
                    }),
                };

            this.listenTo(model, { 'remove': this.remove });
        },
        render: function() {
            this.assign(this.view.infobox, this.$el);
            return this;
        },

        deleteAssignment: function(result) {
            if (result) this.model.destroy({ wait: true });
        },

        ////////////
        // events //
        ////////////
        onActionClick: function(e) {
            e.preventDefault();
        },

        onMenuInit: function() {
            return new Backbone.Collection([
                { caption: 'Delete', icon: "sl-icon-trash", callback: this.onDeleteAction }
            ]);
        },

        onDeleteAction: function() {
            Bootbox.confirm({
                title: i18n.t("Delete assignment"),
                message: i18n.t("messages:message-delete-assignment"),
                onEscape: true,
                backdrop: true,
                callback: this.deleteAssignment,
                context: this,
            });
        },

    });

    return VPerUserAssignmentListItem;

});

